<template>
    <nav class='nav'>
        <img :src="imgUrl" class='imgUrl'>
        <el-row class='row'>
          <el-col :span="8"><div class="grid-content bg-purple"> <img :src="leftIcon" class='leftNavIcon'></div></el-col>
          <el-col :span="5"><div class="grid-content bg-purple-light"></div></el-col>
          <el-col :span="11"><div class="grid-content bg-purple">
            <ul class='iconUl'>
              <li  @click="handleNavClick(item,index)" v-for='(item,index) in navList' :key='index' >
                <a href="javascript:void(0);"><img :src="navSelect==index?item.imgSelect:item.img" alt="" ></a>
              </li>
            </ul>
          </div></el-col>
        </el-row>
       </nav>
</template>
<script>
export default {
  name: 'Home',
  props: {
    navSelectParent: 0
  },
  watch: {
    'navSelectParent' (a) {
      this.navSelect = a
    }
  },
  data () {
    return {
      navSelect: 0,
      imgUrl: require('../assets/nav.png'),
      leftIcon: require('../assets/icon.png'),
      navList: [
        {
          img: require('../assets/shouted.png'),
          href: '#topDiv',
          imgSelect: require('../assets/shouted02.png')
        },
        {
          img: require('../assets/introduction.png'),
          href: '#middleNew',
          imgSelect: require('../assets/introduction01.png')
        },
        {
          img: require('../assets/characteristic.png'),
          href: '#lunarDiv',
          imgSelect: require('../assets/characteristic02.png')
        }
      ]
    }
  },
  mounted () {
    this.navSelect = this.navSelectParent
    if (this.$route.name === 'Home' && this.$route.params.navSelect) {
      var item = this.navList[this.$route.params.navSelect]
      this.handleNavClick(item, this.$route.params.navSelect)
    }
  },
  methods: {
    handleNavClick (item, index) {
      this.navSelect = index
      if (this.$route.name === 'Home') {
        var href = item.href
        document.querySelector(href).scrollIntoView()
      } else {
        this.$router.push({
          name: 'Home',
          params: {
            navSelect: this.navSelect
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
    .imgUrl {
      position:absolute;
      width:100%;
      height:88px;
      line-height:88px;
    }
    .row {
      display:flex;
      flex-direction:row;
      justify-content: space-around;
      align-items: center;
      height:88px;
      padding:0 10%;
      box-sizing: content-box;
    }
    .iconUl {
      display:flex;
      flex-direction:row;
      justify-content: space-around;
      align-items: center;
      box-sizing: content-box;
      width:100%;
    }
    .iconUl li {
      list-style: none;
      align-items: center;
      width:33.33%;
    }
    .iconUl li img {
      width:100%;
    }
    .topDiv {
      width:100vw;
    }
    .middleNew {
      width:100vw;
      position:relative;
      margin-top:-15px;
    }
    .topDiving {
      position:relative
    }
    /* 固定在顶部 */
    .Home {
      position:relative;
      width:100vw;
    }
    .nav {
      position:fixed;
      top:0%;
      z-index:1000;
      width:100vw;
    }
    </style>



// WEBPACK FOOTER //
// src/components/nav.vue